var map = {
	"./404.md": 978,
	"./_template.jsx": 390,
	"./alleyesonus.md": 979,
	"./alleyesonus.sidebar.md": 980,
	"./foerdermitglied.md": 981,
	"./foerdermitglied.sidebar.md": 982,
	"./impressum.md": 983,
	"./impressum.sidebar.md": 984,
	"./index.md": 985,
	"./index.sidebar.md": 986,
	"./lokalrunde.md": 987,
	"./lokalrunde.sidebar.md": 988,
	"./programm/_template.js": 989,
	"./programm/index.js": 1002,
	"./projekte/alleyesonus.md": 1003,
	"./projekte/alleyesonus.sidebar.md": 1004,
	"./projekte/festival.md": 1005,
	"./projekte/festival.sidebar.md": 1006,
	"./projekte/index.js": 1007,
	"./projekte/kanali.md": 1011,
	"./projekte/kanali.sidebar.md": 1012,
	"./projekte/lankenau.md": 1013,
	"./projekte/lankenau.sidebar.md": 1014,
	"./projekte/lokalrunde.md": 1015,
	"./projekte/lokalrunde.sidebar.md": 1016,
	"./projekte/mythos.md": 1017,
	"./projekte/mythos.sidebar.md": 1018,
	"./projekte/quarantaene.md": 1019,
	"./projekte/quarantaene.sidebar.md": 1020,
	"./projekte/sehnsucht.md": 1021,
	"./projekte/sehnsucht.sidebar.md": 1022,
	"./projekte/stahlschnitt.md": 1023,
	"./projekte/stahlschnitt.sidebar.md": 1024,
	"./projekte/theater.md": 1025,
	"./projekte/theater.sidebar.md": 1026,
	"./projekte/traumweltstadt.md": 1027,
	"./projekte/traumweltstadt.sidebar.md": 1028,
	"./satzung.md": 1029,
	"./satzung.sidebar.md": 1030,
	"./tickets.md": 1031,
	"./tickets.sidebar.md": 1032
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 977;



//////////////////
// WEBPACK FOOTER
// . (coffee|cjsx|ts|tsx|jsx|js|md|rmd|mkdn?|mdwn|mdown|markdown|litcoffee|ipynb|html|json|yaml|toml)$
// module id = 977
// module chunks = 0